import HighlightWords from 'react-highlight-words';
import React from 'react';
import { isArray } from 'lodash';
import { Tooltip } from 'antd';

export default function Highlighter({
  text,
  searchValue,
  className,
  showTitle = true,
  showTooltip = false,
  ...props
}) {
  const highlighted = (
    <HighlightWords
      className={className}
      highlightStyle={{ color: '#141F38', backgroundColor: '#FAAB45', padding: 0 }}
      searchWords={searchValue ? (isArray(searchValue) ? searchValue : [searchValue]) : []}
      textToHighlight={text || ''}
      title={showTitle ? text || '' : undefined}
      autoEscape
      {...props}
    />
  );

  if (showTooltip) {
    return <Tooltip title={text}>{highlighted}</Tooltip>;
  }
  return highlighted;
}
